import ShoppingList from './ShoppingList';

export default ShoppingList;
